// extracted by mini-css-extract-plugin
module.exports = {"container":"FormLogin_container__3LJjj","fgt-pwd-wrapper":"FormLogin_fgt-pwd-wrapper__2TUbk"};